import { type CloudinaryOptions } from '../../helpers/cloudinary-helper/cloudinary-helper';

export const PLACEHOLDER_OPTIONS: CloudinaryOptions = { quality: 25, format: 'jpg', effect: 'blur', effectAmount: 2000 };
